import React from 'react';
import { HashRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Login from './pages/Login';
import StoreOwnerDashboard from './pages/StoreOwnerDashboard';
import ClientDashboard from './pages/ClientDashboard';
import AdmDashboard from './pages/AdmDashboard';
import ClientRegistrationPage from './components/ClientRegistrationPage';
import ResetPassword from './pages/ResetPassword';

function AutoLogoutWrapper({ children }) {
  useAutoLogout();
  return children;
}

function useAutoLogout(timeout = 30 * 60 * 1000) {
  const navigate = useNavigate();

  React.useEffect(() => {
    let timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        localStorage.clear();
        navigate('/login');
      }, timeout);
    };

    const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];
    events.forEach(event => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      clearTimeout(timer);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [navigate, timeout]);
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Rotas Públicas */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register-client/:companyId" element={<ClientRegistrationPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Rotas Protegidas */}
        <Route
          path="/storeowner"
          element={<AutoLogoutWrapper><StoreOwnerDashboard /></AutoLogoutWrapper>}
        />
        <Route
          path="/client"
          element={<AutoLogoutWrapper><ClientDashboard /></AutoLogoutWrapper>}
        />
        <Route
          path="/adm"
          element={<AutoLogoutWrapper><AdmDashboard /></AutoLogoutWrapper>}
        />
      </Routes>
    </Router>
  );
}

export default App;